module.exports = __webpack_public_path__ + "static/img/16.a9b3f7ab.png";